module.exports = __webpack_public_path__ + "static/media/3.3324407d.jpg";